export const timeSpanFormatString = "Bra";
export default {timeSpanFormatString};